var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5601",
    "data-name": "Group 5601",
    transform: "translate(-1204.5 -1519.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_464",
    "data-name": "Ellipse 464",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(1205 1520)",
    fill: "#f4f4f4",
    stroke: "#e0e0e0",
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2842",
    "data-name": "Group 2842",
    transform: "translate(584 -59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M11.9,37.853A18.638,18.638,0,0,1,6.336,13.588a.984.984,0,0,1-.149-.149L5.1,12.085A4.914,4.914,0,0,1,5.982,5.05a5.215,5.215,0,0,1,7.173.859l.372.461a18.653,18.653,0,0,1,18.2,0l.372-.461a5.215,5.215,0,0,1,7.173-.859,4.914,4.914,0,0,1,.886,7.035l-1.091,1.354a.984.984,0,0,1-.149.149,18.638,18.638,0,0,1-5.559,24.266l3.687,3.687a.98.98,0,0,1-1.386,1.386l-3.921-3.921a.991.991,0,0,1-.076-.086,18.654,18.654,0,0,1-18.068,0,.991.991,0,0,1-.076.086L9.595,42.927A.98.98,0,1,1,8.209,41.54Zm25.929-26,.807-1a2.953,2.953,0,0,0-.543-4.241,3.254,3.254,0,0,0-4.463.526l-.231.286A18.733,18.733,0,0,1,37.824,11.855Zm-30.4,0a18.733,18.733,0,0,1,4.43-4.429l-.231-.286a3.254,3.254,0,0,0-4.463-.526,2.953,2.953,0,0,0-.543,4.241l.806,1Zm15.2,27.438A16.666,16.666,0,1,0,5.961,22.627,16.666,16.666,0,0,0,22.627,39.293Z",
    transform: "translate(648 1605)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M11.691,12.84a.98.98,0,0,0-1.422,1.35l5.955,6.269a.98.98,0,0,0,1.407.015l9.731-9.8A.98.98,0,1,0,25.97,9.29l-9.02,9.087Z",
    transform: "translate(653.764 1609.803)",
    fill: "#fd9926"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.4f1c1eacd2df08e3ffb4440c0f52b9f2.svg";
export { ForwardRef as ReactComponent };